import { required } from '@vuelidate/validators'

export const PermissionValidation = {
    name: { required },
    description: { required },
    microservice_id: { required },
}
